"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var with_countries_apollo_1 = require("./with_countries_apollo");
var findCountry = function (countryCode, countries) {
    return countries.find(function (c) { return c.countryCode === countryCode; });
};
var countryCodeToName = function (countryCode, countries) {
    var country = findCountry(countryCode, countries);
    return country && country.name;
};
var regionNameInCountry = function (countryCode, regionCode, countries) {
    var country = findCountry(countryCode, countries);
    var region = country && country.subregions.find(function (r) { return (r.code === regionCode); });
    return region && region.name;
};
function AddressSummary(_a) {
    var address = _a.address, data = _a.data;
    var countries = data.countries.countries;
    var countryName = countryCodeToName(address.countryCode, countries);
    var regionName = regionNameInCountry(address.countryCode, address.region, countries);
    return (React.createElement("p", { className: "formatted-address" },
        address.name && React.createElement("span", null,
            address.name,
            React.createElement("br", null)),
        React.createElement("span", { className: "formatted-address__highlight" }, address.streetAddress),
        React.createElement("br", null),
        address.extendedAddress && React.createElement("span", null,
            address.extendedAddress,
            React.createElement("br", null)),
        address.locality,
        ", ",
        regionName,
        " ",
        address.postalCode,
        React.createElement("br", null),
        countryName));
}
exports.AddressSummary = AddressSummary;
var AddressSummaryWithCountries = with_countries_apollo_1.default(AddressSummary);
exports.AddressSummaryWithCountries = AddressSummaryWithCountries;
//# sourceMappingURL=address_summary.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/address_summary.js
// module id = kU1p
// module chunks = 20 21 22